<template>
  <div class="home">
  </div>
</template>

<script>
export default {
}
</script>

<style scoped>
</style>
